import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export class NavMenu extends Component {
  displayName = NavMenu.name

  render() {
    if(localStorage.getItem('tmp') || sessionStorage.getItem('tmp')){
      if(localStorage.getItem('roleType')==='1'){//admin
          return (
              <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                  <Navbar.Brand href="/"><img
                      alt=""
                      src="/icon-1-30x30.gif"
                      width="30"
                      height="30"
                      className="d-inline-block align-top"
                  />{' '}
                      SpinRise</Navbar.Brand>
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                          <Nav.Link href="/">Home</Nav.Link>
                          <Nav.Link href="/timeline">Timeline</Nav.Link>
                          <Nav.Link href="/chartSMS">Charts</Nav.Link>
                          <NavDropdown title="Admin" id="collasible-nav-dropdown">
                              <NavDropdown.Item href="/users">Users</NavDropdown.Item>
                              <NavDropdown.Item href="/roles">Roles</NavDropdown.Item>
                              <NavDropdown.Item href="/userprofile">Profile</NavDropdown.Item>
                              <NavDropdown.Item href="/survey">Survey</NavDropdown.Item>
                          </NavDropdown>
                      </Nav>
                      <Nav>
                          <Nav.Link href="/logout">Logout</Nav.Link>
                      </Nav>
                  </Navbar.Collapse>
              </Navbar>
        );
      }
      else if(localStorage.getItem('roleType')==='2'){//parent
          return (
              <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                  <Navbar.Brand href="/"><img
                      alt=""
                      src="/icon-1-30x30.gif"
                      width="30"
                      height="30"
                      className="d-inline-block align-top"
                  />{' '}
                      SpinRise</Navbar.Brand>
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                          <Nav.Link href="/">Home</Nav.Link>
                          <Nav.Link href="/timeline">Timeline</Nav.Link>
                          <Nav.Link href="/chartSMS">Charts</Nav.Link>
                          <NavDropdown title="Settings" id="collasible-nav-dropdown">
                              <NavDropdown.Item href="/users">Users</NavDropdown.Item>
                              <NavDropdown.Item href="/children">Children</NavDropdown.Item>
                              <NavDropdown.Item href="/userprofile">Profile</NavDropdown.Item>
                              <NavDropdown.Item href="/survey">Survey</NavDropdown.Item>
                          </NavDropdown>
                      </Nav>
                      <Nav>
                          <Nav.Link href="/logout">Logout</Nav.Link>
                      </Nav>
                  </Navbar.Collapse>
              </Navbar>
          );
      }
      else if(localStorage.getItem('roleType')==='3'){//Therapist
          return (
              <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                  <Navbar.Brand href="/"><img
                      alt=""
                      src="/icon-1-30x30.gif"
                      width="30"
                      height="30"
                      className="d-inline-block align-top"
                  />{' '}
                      SpinRise</Navbar.Brand>
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                          <Nav.Link href="/">Home</Nav.Link>
                          <Nav.Link href="/timeline">Timeline</Nav.Link>
                          <Nav.Link href="/chartSMS">Charts</Nav.Link>
                          <NavDropdown title="Settings" id="collasible-nav-dropdown">
                              <NavDropdown.Item href="/userprofile">Profile</NavDropdown.Item>
                          </NavDropdown>
                      </Nav>
                      <Nav>
                          <Nav.Link href="/logout">Logout</Nav.Link>
                      </Nav>
                  </Navbar.Collapse>
              </Navbar>
        );
      }
      else if(localStorage.getItem('roleType')==='4'){//Caregiver
          return (
              <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                  <Navbar.Brand href="/"><img
                      alt=""
                      src="/icon-1-30x30.gif"
                      width="30"
                      height="30"
                      className="d-inline-block align-top"
                  />{' '}
                      SpinRise</Navbar.Brand>
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                          <Nav.Link href="/">Home</Nav.Link>
                          <Nav.Link href="/timeline">Timeline</Nav.Link>
                          <Nav.Link href="/chartSMS">Charts</Nav.Link>
                          <NavDropdown title="Settings" id="collasible-nav-dropdown">
                              <NavDropdown.Item href="/userprofile">Profile</NavDropdown.Item>
                          </NavDropdown>
                      </Nav>
                      <Nav>
                          <Nav.Link href="/logout">Logout</Nav.Link>
                      </Nav>
                  </Navbar.Collapse>
              </Navbar>
        );
      }
      else{
          return (
              <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                  <Navbar.Brand href="/"><img
                      alt=""
                      src="/icon-1-30x30.gif"
                      width="30"
                      height="30"
                      className="d-inline-block align-top"
                  />{' '}
                      SpinRise</Navbar.Brand>
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav className="mr-auto">
                          <Nav.Link href="/">Home</Nav.Link>
                      </Nav>
                  </Navbar.Collapse>
              </Navbar>
        );
      }
    }
    else
    {
        return (
            <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                <Navbar.Brand href="/"><img
                    alt=""
                    src="/icon-1-30x30.gif"
                    width="30"
                    height="30"
                    className="d-inline-block align-top"
                />{' '}
                    SpinRise</Navbar.Brand>
            </Navbar>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Share/NavMenu.js